// Activity Classification Keys
export const GRAMMAR_KEY = 'sentence'
export const DIAGNOSTIC_KEY = 'diagnostic'
export const CONNECT_KEY = 'connect'
export const LESSONS_KEY = 'lessons'
export const EVIDENCE_KEY = 'evidence'
export const PROOFREADER_KEY = 'passage'
